module.exports = __webpack_public_path__ + "img/hzbk@2x.25bddd5a.png";